const _temp0 = require("./bruzz.svg");
const _temp1 = require("./dagelijksekost.svg");
const _temp2 = require("./eos.svg");
const _temp3 = require("./gondola.svg");
const _temp4 = require("./goplay.svg");
const _temp5 = require("./joker.svg");
const _temp6 = require("./klj.svg");
const _temp7 = require("./mediarte.svg");
const _temp8 = require("./mediawijs.svg");
const _temp9 = require("./motoren-toerisme.svg");
const _temp10 = require("./nuvoormorgen.svg");
const _temp11 = require("./ptb.svg");
const _temp12 = require("./pvda.svg");
const _temp13 = require("./sbsbelgium.svg");
const _temp14 = require("./uzleuven.svg");
const _temp15 = require("./vier.svg");
const _temp16 = require("./vrtsales.svg");
const _temp17 = require("./watwat.svg");
const _temp18 = require("./wieni.svg");
const _temp19 = require("./wtfock.svg");
module.exports = {
  "bruzz": _temp0,
  "dagelijksekost": _temp1,
  "eos": _temp2,
  "gondola": _temp3,
  "goplay": _temp4,
  "joker": _temp5,
  "klj": _temp6,
  "mediarte": _temp7,
  "mediawijs": _temp8,
  "motoren-toerisme": _temp9,
  "nuvoormorgen": _temp10,
  "ptb": _temp11,
  "pvda": _temp12,
  "sbsbelgium": _temp13,
  "uzleuven": _temp14,
  "vier": _temp15,
  "vrtsales": _temp16,
  "watwat": _temp17,
  "wieni": _temp18,
  "wtfock": _temp19
}